import { createUseRepositoryMutation, MutationOptions as MutationOptionsRaw } from '@mews/framework';
import { AnyFunction } from '@mews/std';
import type { RepositoryRegistry } from '../createRegistry';
import { useRepositoryRegistry } from './RepositoryRegistryContext';

export type MutationOptions<
    RepositoryName extends keyof RepositoryRegistry,
    MethodName extends keyof RepositoryRegistry[RepositoryName],
    Params = Parameters<
        RepositoryRegistry[RepositoryName][MethodName] extends AnyFunction
            ? RepositoryRegistry[RepositoryName][MethodName]
            : never
    >[0],
> = MutationOptionsRaw<RepositoryRegistry, RepositoryName, MethodName, Params>;

type UseRepositoryMutation = ReturnType<typeof createUseRepositoryMutation<RepositoryRegistry>>;
export const useRepositoryMutation: UseRepositoryMutation = createUseRepositoryMutation(useRepositoryRegistry);
